/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_DpaInputs */

const cs_auth_signup_dpa = /** @type {(inputs: Auth_Signup_DpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhlasím se smlouvou o zpracování osobních údajů (DPA)`)
};

const en_auth_signup_dpa = /** @type {(inputs: Auth_Signup_DpaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I agree to the data processing agreement (DPA)`)
};

/**
* | output |
* | --- |
* | "I agree to the data processing agreement (DPA)" |
*
* @param {Auth_Signup_DpaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_dpa = /** @type {((inputs?: Auth_Signup_DpaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_DpaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_dpa(inputs)
	return cs_auth_signup_dpa(inputs)
});